import {api} from '../components/Base/App';

export default {
    getAllLanguages() {
        return api.get('/rest/languages', {
        });
    },

    getTranslateByCode(code) {
        return api.get('/rest/languages/' + code, {
        });
    }
};


// WEBPACK FOOTER //
// ./src/api/Languages.js